export const COMPANY_LOGO_ACCEPT = ['image/png', '.png'] as const;

export const COMPANY_LOGO_HELPER_TEXT =
  'Use PNG image with a transparent background.';

export interface LogoFileCandidate {
  mimetype?: string;
  filename?: string;
}

export function isPngLogoFile(file: LogoFileCandidate): boolean {
  const mime = (file.mimetype || '').toLowerCase();
  if (mime === 'image/png') {
    return true;
  }

  const name = (file.filename || '').toLowerCase();
  return name.endsWith('.png');
}

export function assertPngLogoFile(file: LogoFileCandidate): void {
  if (!isPngLogoFile(file)) {
    throw new Error('Company logo must be a PNG file.');
  }
}

export function slugifyCompanyName(companyName: string): string {
  return companyName
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
}

export function buildCompanyLogoFileName(companyName: string): string {
  const slug = slugifyCompanyName(companyName);
  return `${slug}-logo.png`;
}
